import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom"; // Importa useNavigate

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate(); // Inicializa useNavigate

  // Función para sanitizar el input y prevenir inyección de scripts
  const sanitizeInput = (input) => {
    const tempElement = document.createElement("div"); // Crea un elemento temporal
    tempElement.textContent = input; // Asigna el input al contenido de texto
    return tempElement.innerHTML; // Devuelve el contenido sanitizado
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Sanitizar el nombre de usuario antes de enviarlo al servidor
      const sanitizedUsername = sanitizeInput(username);

      // No sanitizamos la contraseña para no alterar su valor real
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/login`,
        {
          username: sanitizedUsername,
          password: password,
        }
      );

      if (response.status) {
        onLogin(); // Llama a la función de inicio de sesión de App
        Swal.fire("Éxito", "Inicio de sesión exitoso", "success");
        navigate("/dashboard"); // Redirige a /dashboard
      } else {
        Swal.fire("Error", "Credenciales incorrectas", "error");
      }
    } catch (error) {
      console.error("Error en el inicio de sesión:", error);
      Swal.fire("Error", "Ocurrió un error al iniciar sesión", "error");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-sm p-6 bg-white rounded-lg shadow-md">
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-700">
          Iniciar Sesión
        </h2>
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-gray-600">Usuario</label>
            <input
              type="text"
              className="w-full p-2 border rounded-md"
              value={username}
              onChange={(e) => setUsername(sanitizeInput(e.target.value))} // Sanitiza el input al cambiar
              required
            />
          </div>
          <div>
            <label className="block text-gray-600">Contraseña</label>
            <input
              type="password"
              className="w-full p-2 border rounded-md"
              value={password}
              onChange={(e) => setPassword(e.target.value)} // No sanitizamos la contraseña
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600 transition"
          >
            Iniciar Sesión
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
